<template>
    <footer id="footer-bar" class="row" style="opacity: 1;">
        <p id="footer-copyright">
            Copyright © 2014 Tanikawa. Powered by <a href="http://www.tanikawax.com" target="_blank">tanikawax.com.</a>
        </p>
        <p></p>
        <ul id="footer-sidebar">
            <li v-if="matchItemDetailPage($route.name)" id="b_card" class="sidebar-icon" @click="goAnchor('#_item_card')" @mouseover="changeWidth('b_card')" @mouseleave="changeWidth('b_card', 0)">
                <a style="color:#fff">
                    <span>快速到名片区</span>
                    <i class="fa fa-id-card-o" style="font-size: 24px;"></i>
                </a>
            </li>
            <li v-if="matchItemDetailPage($route.name,true)" id="b_remark" class="sidebar-icon" @click="goAnchor('#_item_remark')" @mouseover="changeWidth('b_remark')" @mouseleave="changeWidth('b_remark', 0)">
                <a style="color:#fff">
                    <span>快速到备注区</span>
                    <i class="fa fa-comments-o" style="font-size: 24px;"></i>
                </a>
            </li>
            <li id="b_code" class="sidebar-icon" @mouseover="showAppPhone=true" @mouseleave="showAppPhone=false">
                <a style="color:#fff">
                    <i class="fa fa-mobile" style="font-size: 24px;"></i>
                </a>
                <ul class="dropdown-menu notifications-list messages-list" id="ewmbox" :class="{show:showAppPhone}">
                    <li class="item first-item erweimabox">
                            <h3>扫描二维码下载手机软件</h3>
                            <div class="erweimabody">
                                <img src="../../../assets/images/qrcode-slide.png" id="ewm_android">
                                <p>北屯招商云客户端</p>
                                <router-link to="/app-download/2" target="_blank">
                                    <div class="android">Android版</div>
                                </router-link>
                                <router-link to="/app-download/1" target="_blank">
                                    <div class="iphone">iPhone版</div>
                                </router-link>
                            </div>
                        </li>
                    <li class="item-footer">
                        <a href="">
                            你的工作站
                        </a>
                    </li>
                </ul>
            </li>
            <li id="b_totop" class="sidebar-icon" @click="toTop" @mouseover="changeWidth('b_totop')" @mouseleave="changeWidth('b_totop', 0)">
                <a href="#" style="color:#fff">
                    <span>回到顶部</span>
                    <i class="fa fa-chevron-up" style="font-size: 24px;"></i>
                </a>
            </li>
        </ul>
    </footer>
</template>
<script>

import $ from 'jquery'
import $api from "@/service/index";
import utils from "@/utils";
import SimpleUpload from "@/components/upload/simpleUpload/SimpleUpload";
import LabelTip from "@/components/labelTip/labelTip.vue";
import Cookie from "js-cookie"
import Config from "@/config.js";

export default {
    components:{
        SimpleUpload,
        LabelTip
    },
    data() {
        return {
            uploadUrl : Config.apiUrl + `/callback-upload`,
            itemDetailPage : false,
            //划过手机图标时的显示
            showAppPhone: false,
            //划过消息图标时的显示
            showFeedback: false,
            //问题反馈表单
            feedbackForm:{
                type: 2,
                pic_ids: []
            },
            //问题反馈表单的验证
            validateRules: {
                content: [{ required: true, message: '请填写反馈内容'}],
                caller: [{ required: true, message: '请填写反馈人'}],
                callurl: [{ required: true, message: '请填写反馈网址'}]
            },
            //上传组件的样式定义
            uploadOption: {
                cMyDropzone:{
                    padding: '0 10px',
                    minHeight:'146px'
                },
                cMyImg: {
                    width: '50px',
                    height: '50px'
                },
                cMyDelete: {
                    lineHeight: '20px'
                }
            },
        } 
    },
    watch: {
        showFeedback: function(newVal){
            if(newVal === true){
                this.$refs.feedbackUpload.fresh();
            }
        },
        '$route' : function(){
            if (this.showFeedback) {
                this.showFeedback = false;
            }
        }
    },
    computed: {
        //用户信息
        userinfo(){
            return this.$store.state.commonData.userinfo;
        }
    },
    methods: {
        //回到顶部
        toTop(){
            this.$parent.$refs.pagebody.scrollTo(0, 0);
        },
        //动画显示
        changeWidth(ele, wid=100){
            $('#' + ele + ' span').animate({width:wid},0);
        },
        //提交表单
        submitFeedback(){
            let status = true;
            this.$refs.refFeedback.validate((valid)=>{
                status = status && valid;
            });
            if(status === false){
                return ;
            }
            let data = this.feedbackForm;
            data.pic_ids = this.$refs.feedbackUpload.getFileIds();
            let _self = this;
            $api.feedback(data).then(()=>{
                _self.showFeedback = false;
                _self.resetForm();
            });
        },
        //重置表单
        resetForm(){
            this.$refs.refFeedback.resetFields();
            this.feedbackForm.pic_ids = [];
            this.feedbackForm.contact = undefined;
        },
        /**
         * 判断路由是否为项目详情页
         * @param {string} route 路由名字
         * @param {bool} matchCarrier 是否匹配载体路由
         * @return {boolean}
         */
        matchItemDetailPage(route,matchCarrier=false){
            if(!route){
                return false;
            }

            let res = utils.getItemDetailUrl(route,'num');
            if(res === "" && matchCarrier===true){
                res = utils.getCarrierDetailUrl(route,'num');
            }
            return res !== "";
        },
        /**
         * 超级锚点定位（模拟）,被定位的div外层不能有浮动否则会因为脱离文档流而无效
         * @param {string} selector 选择器内容
         * @returns {boolean}
         */
        goAnchor(selector){
            let anchor = document.querySelector(selector);
            if(!anchor){
                return false;
            }
            document.body.scrollTop = anchor.offsetTop; // chrome
            document.documentElement.scrollTop = anchor.offsetTop; // firefox
        },
        /**
         * 点击了反馈
         */
        clickFeedback(){
            this.feedbackForm.caller = this.userinfo.username;
            this.feedbackForm.callurl = window.location.href;
            this.showFeedback = true;
        }
    },
    mounted() {
    }
};
</script>


<style scoped>
@import './commonFooter.less';
</style>


// WEBPACK FOOTER //
// src/pages/layout/business/CommonFooter.vue